import { render, staticRenderFns } from "./addUsdtCard.vue?vue&type=template&id=4ed8e7ed&scoped=true"
import script from "./addUsdtCard.vue?vue&type=script&lang=js"
export * from "./addUsdtCard.vue?vue&type=script&lang=js"
import style0 from "./addUsdtCard.vue?vue&type=style&index=0&id=4ed8e7ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed8e7ed",
  null
  
)

export default component.exports